// Third Party
import { AccountReviewSummary } from '@gql';

// UI
import googleReview from '../../../public/assets/svg/ratings/google-logo.svg';
import { RatingStars } from '@components/rating-stars';
import Image from 'next/image';

type Props = { reviewSummary: AccountReviewSummary };

export const GoogleRatingsDisplay: React.FC<Props> = ({ reviewSummary }) => {
  return (
    <div>
      <div className="relative w-20 mb-2">
        <Image
          layout="responsive"
          src={googleReview}
          className="object-cover object-center"
          alt="Savvy google review"
        />
      </div>

      <div className="flex flex-row">
        <span className="text-alert-main text-sm font-bold">
          {reviewSummary.rating}/{5}
        </span>
        <span className="pl-1 flex flex-row">
          <RatingStars rating={reviewSummary.rating} />
        </span>
        <span
          className="pl-8
       text-sm font-bold z-20"
        >
          ({reviewSummary.numberOfReviews || 1})
        </span>
      </div>
    </div>
  );
};
